import React from 'react';
export function Footer() {
  return <footer className="bg-pine-deep px-5 py-12 text-center" data-id="element-78" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-content" data-id="element-79" data-mp="3gfiugihumbe4">
        <p className="font-display text-base font-bold tracking-wide text-white" data-id="element-80" data-mp="3ghc3u5juj9pt">LACROSSE READY 360™</p>
        <p className="mx-auto mt-3 max-w-lg text-xs leading-relaxed text-white/60" data-id="element-81" data-mp="32lrm3dfusxjz">
          The complete, ready-to-use girls&apos; lacrosse curriculum for coaches and PE teachers. U8 to U17.
        </p>
        <nav aria-label="Footer" className="mt-7 flex items-center justify-center gap-4 text-xs text-white/70" data-id="element-82" data-mp="3ud7g3sjqpmk8">
          <a href="#terms" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-83" data-mp="3lec94e8vg8fv">
            Terms
          </a>
          <span aria-hidden="true" className="text-white/30" data-id="element-84" data-mp="3qcniyoz62iy3">
            ·
          </span>
          <a href="#privacy" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-85" data-mp="29ynk7hc24zcf">
            Privacy
          </a>
          <span aria-hidden="true" className="text-white/30" data-id="element-86" data-mp="2ezuvhqdesgnu">
            ·
          </span>
          <a href="#contact" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-87" data-mp="3labqttpu02pb">
            Contact
          </a>
        </nav>
        <p className="mt-7 text-[11px] text-white/45" data-id="element-88" data-mp="3v7q7nufo2ti5">© 2026 Lacrosse Ready 360 — All rights reserved.</p>
      </div>
    </footer>;
}